import React from 'react';
export function PrivacyPolicyContent() {
  return <>
      <p className="mb-2.5" data-id="element-148">Última actualización: Enero 2026</p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-149">
        1. Información que Recopilamos
      </h3>
      <p className="mb-2.5" data-id="element-150">
        Recopilamos información que nos proporcionas directamente al realizar
        una compra, incluyendo nombre, dirección de correo electrónico e
        información de pago procesada de forma segura a través de nuestro
        procesador de pagos.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-151">
        2. Uso de la Información
      </h3>
      <p className="mb-2.5" data-id="element-152">
        Utilizamos tu información exclusivamente para procesar tu pedido, enviar
        los materiales digitales adquiridos y comunicaciones relacionadas con tu
        compra.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-153">
        3. Cookies y Tecnologías de Seguimiento
      </h3>
      <p className="mb-2.5" data-id="element-154">
        Utilizamos cookies y el Pixel de Meta para mejorar tu experiencia y
        optimizar nuestras campañas publicitarias. Puedes desactivar las cookies
        en la configuración de tu navegador.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-155">
        4. Compartir Información
      </h3>
      <p className="mb-2.5" data-id="element-156">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros, excepto los necesarios para procesar tu pago y entregar tu
        pedido (procesadores de pago y plataformas de entrega digital).
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-157">5. Seguridad</h3>
      <p className="mb-2.5" data-id="element-158">
        Implementamos medidas de seguridad estándar de la industria para
        proteger tu información personal. Todas las transacciones se procesan
        con encriptación SSL.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-159">6. Tus Derechos</h3>
      <p className="mb-2.5" data-id="element-160">
        Tienes derecho a acceder, corregir o solicitar la eliminación de tu
        información personal. Para ejercer estos derechos, puedes contactarnos a
        través de nuestra plataforma de soporte.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-161">
        7. Cambios a Esta Política
      </h3>
      <p className="mb-2.5" data-id="element-162">
        Nos reservamos el derecho de actualizar esta política. Los cambios
        significativos serán notificados a través de nuestro sitio web.
      </p>
    </>;
}
export function TermsOfServiceContent() {
  return <>
      <p className="mb-2.5" data-id="element-163">Última actualización: Enero 2026</p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-164">
        1. Aceptación de los Términos
      </h3>
      <p className="mb-2.5" data-id="element-165">
        Al adquirir cualquier producto de B.E.B.E. 365, aceptas estos términos
        de servicio en su totalidad. Si no estás de acuerdo con alguno de estos
        términos, no debes utilizar nuestros productos.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-166">
        2. Productos Digitales
      </h3>
      <p className="mb-2.5" data-id="element-167">
        Todos nuestros productos son de descarga digital. Recibirás acceso
        inmediato a través del correo electrónico proporcionado en la compra. No
        se envían productos físicos.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-168">3. Licencia de Uso</h3>
      <p className="mb-2.5" data-id="element-169">
        Al adquirir nuestros productos, obtienes una licencia personal, no
        transferible, para uso personal únicamente. Queda estrictamente
        prohibida la redistribución, venta, o compartición de los materiales con
        terceros.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-170">
        4. Política de Reembolso
      </h3>
      <p className="mb-2.5" data-id="element-171">
        Ofrecemos una garantía de satisfacción de 30 días. Si no estás
        satisfecho con tu compra, puedes solicitar un reembolso completo dentro
        de los 30 días posteriores a la compra a través de nuestra plataforma de
        soporte.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-172">
        5. Propiedad Intelectual
      </h3>
      <p className="mb-2.5" data-id="element-173">
        Todo el contenido de B.E.B.E. 365, incluyendo textos, imágenes, diseños
        y metodologías, está protegido por derechos de autor. Está prohibida su
        reproducción sin autorización expresa.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-174">
        6. Limitación de Responsabilidad
      </h3>
      <p className="mb-2.5" data-id="element-175">
        B.E.B.E. 365 proporciona información educativa. No somos responsables de
        decisiones tomadas basándose en nuestro contenido. Siempre consulta a
        profesionales de la salud para decisiones médicas.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-176">7. Modificaciones</h3>
      <p className="mb-2.5" data-id="element-177">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. El uso continuado de nuestros productos constituye aceptación
        de los términos modificados.
      </p>
    </>;
}
export function DisclaimerContent() {
  return <>
      <p className="mb-2.5" data-id="element-178">Última actualización: Enero 2026</p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-179">
        Propósito Educativo
      </h3>
      <p className="mb-2.5" data-id="element-180">
        Todo el contenido de B.E.B.E. 365, incluyendo el Protocolo Principal y
        los 4 Bonos, es de naturaleza exclusivamente educativa e informativa. No
        constituye consejo médico, diagnóstico ni tratamiento.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-181">
        Consulta Profesional
      </h3>
      <p className="mb-2.5" data-id="element-182">
        Siempre consulta con tu pediatra, médico de familia u otro profesional
        de la salud calificado antes de implementar cambios en la rutina de tu
        bebé, especialmente en lo relacionado con sueño, alimentación o
        desarrollo.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-183">
        Resultados No Garantizados
      </h3>
      <p className="mb-2.5" data-id="element-184">
        Los resultados mencionados en este sitio son experiencias individuales y
        no son típicos ni garantizados. Cada bebé es único y los resultados
        variarán según múltiples factores incluyendo la edad, el temperamento y
        la consistencia en la aplicación.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-185">Testimonios</h3>
      <p className="mb-2.5" data-id="element-186">
        Los testimonios presentados en este sitio son experiencias reales de
        usuarios pero no representan resultados típicos. No garantizamos que
        obtendrás los mismos resultados.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-187">Afiliación</h3>
      <p className="mb-2.5" data-id="element-188">
        Este sitio no está afiliado, asociado, autorizado, respaldado ni
        conectado de ninguna manera oficial con Meta Platforms Inc., Facebook™,
        Instagram™, WhatsApp™ o cualquier otra empresa mencionada en este
        sitio.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-189">
        Emergencias Médicas
      </h3>
      <p className="mb-2.5" data-id="element-190">
        Si tu bebé presenta síntomas de emergencia médica, llama inmediatamente
        a los servicios de emergencia de tu país. No uses este material como
        sustituto de atención médica de emergencia.
      </p>
    </>;
}